module.exports = exports = {
  PublicClient: require('./lib/clients/public'),
  AuthenticatedClient: require('./lib/clients/authenticated')
};
